module.exports = __webpack_public_path__ + "img/GDC.2673ca07.jpg";